export default {options:{api:'billing',version:1},children:[{options:{key:'chargeable',type:'value'}},{options:{key:'costObject',type:'value'}}]}